<template>
  <div style="min-width:1300px; max-width: 1300px; min-height:670px; max-height: 670px; background-color: #0D2440">
    <FiPageRail v-if="!standalone" title="Arrivals & Departures" />

    <div v-if="!standalone" style="font-size: 24px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      Locations:&nbsp;&nbsp;<span v-if="base_options.length > 0"><b-form-select v-model="selected_base" :options="base_options" style="font-size: 24px; font-weight: bold; width:200px"/></span>
      &nbsp;&nbsp;|&nbsp;&nbsp;<span>Expire Hours&nbsp;&nbsp;<b-form-select v-model="selected_expire_hours" :options="hours_options" style="font-size: 24px; font-weight: bold; width:80px"/></span>
      &nbsp;&nbsp;|&nbsp;&nbsp;<span>Next Hours&nbsp;&nbsp;<b-form-select v-model="selected_next_hours" :options="hours_options" style="font-size: 24px; font-weight: bold; width:80px"/></span>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b-btn size="sm" @click="load_data()"><span style="font-size: 20px; font-weight: bold">Get Results</span></b-btn>
    </div>

    <div v-if="!loading && selected_base" align="center" class="main-table" style="background-color: transparent">
      <table width="100%">
        <tr>
          <th colspan="7" class="th2">Departures <span class="th1">(Last {{selected_expire_hours}} Hours, Next {{selected_next_hours}} Hours)</span></th>
        </tr>
        <template v-if="departures.length > 0">
          <tr class="th3">
            <th>Route</th>
            <th>Vehicle</th>
            <th>Departure</th>
            <th>Arrival</th>
            <th>Depart Time</th>
            <th>Arrive Time</th>
            <th style="text-align: center">Departure Status</th>
          </tr>
          <tr v-for="item in departures">
            <td>{{ item.routeName }}</td>
            <td>{{ item.vehicle }}</td>
            <td>{{ item.pickup }}</td>
            <td>{{ item.destination }}</td>
            <td class="td-bold">{{item.planned_departure_time}}</td>
            <td class="td">{{item.planned_arrival_time}}</td>
            <td v-if="item.departure_status.indexOf('Late') != -1" style="color:#EF4053;" class="td-bold-center">{{ item.departure_status }}</td>
            <td v-else-if="item.departure_status.indexOf('Early') != -1" style="color:#61B662;" class="td-bold-center">{{ item.departure_status }}</td>
            <td v-else-if="item.departure_status.indexOf('Scheduled') != -1" style="color:#FF9333;" class="td-bold-center">{{ item.departure_status }}</td>
            <td v-else class="td-bold-center" style="color:#000080;">{{ item.departure_status }}</td>
          </tr>
        </template>
        <tr v-else>
          <td colspan="7">no departures found for {{selected_base}}</td>
        </tr>
        <tr>
          <th colspan="7" class="th2">Arrivals <span class="th1">(Last {{selected_expire_hours}} Hours, Next {{selected_next_hours}} Hours)</span></th>
        </tr>
        <template v-if="arrivals.length > 0">
          <tr v-if="arrivals.length > 0" class="th3">
            <th>Route</th>
            <th>Vehicle</th>
            <th>Departure</th>
            <th>Arrival</th>
            <th>Depart Time</th>
            <th>Arrive Time</th>
            <th style="text-align: center">Arrival Status</th>
          </tr>
          <tr v-for="item in arrivals">
            <td>{{ item.routeName }}</td>
            <td>{{ item.vehicle }}</td>
            <td>{{ item.pickup }}</td>
            <td>{{ item.destination }}</td>
            <td class="td">{{item.planned_departure_time}}</td>
            <td class="td-bold">{{item.planned_arrival_time}}</td>
            <td v-if="item.arrival_status.indexOf('Late') != -1" style="color:#EF4053;" class="td-bold-center">{{ item.arrival_status }}</td>
            <td v-else-if="item.arrival_status.indexOf('Early') != -1" style="color:#61B662;" class="td-bold-center">{{ item.arrival_status }}</td>
            <td v-else-if="item.arrival_status.indexOf('Scheduled') != -1" style="color:#FF9333;" class="td-bold-center">{{ item.arrival_status }}</td>
            <td v-else style="color:#000080;" class="td-bold-center">{{ item.arrival_status }}</td>
          </tr>
        </template>
        <tr v-else>
          <td colspan="7">no arrivals found for {{selected_base}}</td>
        </tr>
      </table>
    </div>
    <div v-else-if="selected_base">
      <b-spinner style="width: 2.5rem; height: 2.5rem;" label="Loading..."></b-spinner>
    </div>    
  </div>

</template>

<script>

import {get_booking_dashboard} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'

export default {
  name: 'arrivals_departures_board',
  components: {
  },

  data() {
    return {
      tenant_id: null,
      arrivals: [],
      departures: [],
      selected_status: null,
      summary: [],
      loading: false,
      standalone: true,
      company_options: [],
      selected_expire_hours: '6',
      selected_next_hours: '12',
      hours_options: [
        { value: '1', text: '1' },
        { value: '2', text: '2' },
        { value: '4', text: '4' },
        { value: '6', text: '6' },
        { value: '8', text: '8' },
        { value: '12', text: '12' },
        { value: '18', text: '18' },
        { value: '24', text: '24' },
      ],
      base_options: [
        { value: 'Duluth', text: 'Duluth' },
        { value: 'Duluth (U of M)', text: 'Duluth (U of M)' },
        { value: 'Billings', text: 'Billings' },
        { value: 'Missoula', text: 'Missoula' },
        { value: 'Mason City', text: 'Mason City' },
        { value: 'Kansas City', text: 'Kansas City' },
        { value: 'St. Paul', text: 'St. Paul' },
        { value: 'Minneapolis', text: 'Minneapolis' },
        { value: 'Ames', text: 'Ames' },
        { value: 'Sioux Falls', text: 'Sioux Falls' },
        { value: 'Des Moines', text: 'Des Moines' },
        { value: 'Fargo', text: 'Fargo' },
        { value: 'Dickinson', text: 'Dickinson' },
      ],
      selected_company: '',
      selected_base: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
    }
  },

  async created() {
    await this.check_features()
  },
  methods: {
    async check_features() {

      if (this.$route.path.indexOf('/arr-dep-board/') == -1) {
        this.standalone = false
        this.tenant_id = this.user.tenant
      }
      else {
        let filter = this.$route.path.split('/arr-dep-board/')[1]
        console.log("filter: " + filter)
        this.tenant_id = filter.split('/')[0]
        this.selected_base = filter.split('/')[1]
        this.selected_expire_hours = filter.split('/')[2]
        this.selected_next_hours = filter.split('/')[3]
        this.standalone = true
        this.load_data()
      }
    },
    async load_data() {
      this.loading = true
      try {
        try {
          const {value: {data = []}} = await get_booking_dashboard(this.tenant_id, this.selected_base, this.selected_expire_hours, this.selected_next_hours)
          this.summary = data.summary
          moment.tz.setDefault(this.summary.timezone)
          this.arrivals = data.arrivals
          this.departures = data.departures
        } catch(e){
          this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
        }
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true
    }
  }
}
</script>

<style scoped>

.main-table {
  //zoom: 160%;
  font-family: Calibri, Candara, Segoe, 'Segoe UI', Optima, Arial, sans-serif;
}

table {
  border-spacing: 0px;
  border: 1px;
  box-shadow: 0 0 15px 0 rgba(0,0,0,.5);
  background-color: rgb(128, 128, 128);
}

table td {
  padding:3px 3px 3px 10px;
  font-size: 16pt;
}

.th1 {
  font-size: 16pt;
  padding-left:10px;
}

table th {
  background-color: black;
  color: white;
  font-size: 18pt;
  padding:5px;
}

.th2 {
  background-color: #808080;
  color: white;
  font-size: 22pt;
}

.th3 {
  background-color: black;
  color: white;
  font-size: 18pt;
}

tr:nth-child(even) {
  background-color: #dce6f1 !important;
  color: #1d4c72;
}
tr:nth-child(odd) {
  background-color: #b8cce4 !important;
  color: #1d4c72;
}

.td-bold {
  font-weight: bold;
  font-style: italic;
}

.td-bold-center {
  font-size: 22px;
  font-weight: bold;
  font-style: italic;
  text-align: center;
}

</style>

